import { useEffect, useState } from "react";
import { getNavigation, NavigationData } from "../contentfulService";

export default function Navigation() {
    const [navigation, setNavigation] = useState<NavigationData | null>(null);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        getNavigation().then(setNavigation);
    }, []);

    if (!navigation) return null;

    return (
        <nav className="w-full bg-black fixed z-20">
            <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">

                {/* Logo */}
                {navigation.logoUrl && (
                    <img
                        src={navigation.logoUrl}
                        alt="Logo"
                        className="h-10 w-auto object-contain"
                    />
                )}

                {/* Desktop Navigation */}
                <ul className="hidden md:flex items-center gap-8 text-sm font-medium text-white">
                    {navigation.items.map((item) => (
                        <li key={item.href}>
                            <a
                                href={item.href}
                                className="relative transition-colors
                after:content-[''] after:absolute after:left-0 after:-bottom-1
                after:h-px after:w-0 after:bg-current
                hover:after:w-full after:transition-all"
                            >
                                {item.label}
                            </a>
                        </li>
                    ))}
                </ul>

                {/* Mobile Hamburger */}
                <button
                    className="md:hidden text-white text-2xl"
                    onClick={() => setOpen(true)}
                    aria-label="Menü öffnen"
                >
                    ☰
                </button>
            </div>

            {/* Mobile Menu Overlay */}
            {open && (
                <div className="fixed inset-0 bg-black z-30 flex flex-col">
                    <div className="flex items-center justify-between px-6 h-16">
                        <span className="text-white font-medium">Menü</span>
                        <button
                            className="text-white text-2xl"
                            onClick={() => setOpen(false)}
                            aria-label="Menü schließen"
                        >
                            ✕
                        </button>
                    </div>

                    <ul className="flex flex-col gap-6 px-6 pt-10 text-lg text-white">
                        {navigation.items.map((item) => (
                            <li key={item.href}>
                                <a
                                    href={item.href}
                                    onClick={() => setOpen(false)}
                                    className="block"
                                >
                                    {item.label}
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </nav>
    );
}
